import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, DataCard, inject, Loader } from 'Mri.Web.Common';
import * as React from 'react';
import { BiStore, Labels } from '../BI/BiStore';
import { AppStore } from '../Core/AppStore';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';
import { LabelStore } from './LabelStore';

export interface IDisplayStatusCardsProps {
    onClick(label: Labels): any;
    readonly title?: string;
    readonly loading: boolean;
    readonly vm: DisplayListViewModel;
}

@autoinject
@observer
export class DisplayStatusCards extends React.Component<IDisplayStatusCardsProps> {
    public render() {
        return (
            <div className="h-100 d-flex flex-column">
                <p className="w-100 text-center mb-1">Display Video Status</p>
                <div className="card h-100 p-3">
                    <div className="row h-100">
                        <div className="col-12 text-center">
                            <div className="flex-items-center h-100">
                                <div className="text-center w-100">
                                    {this.props.vm.total >= 0 && (
                                        <h1
                                            className={`mb-0 d-inline-block dash-total-height dash-total-${this.statusColor}`}
                                        >
                                            {this.props.vm.total}
                                        </h1>
                                    )}
                                    <Loader showSpinner center loading={this.props.loading} />

                                    <p>{this.biStore.dashboardDisplaysTitle}</p>
                                    {this.liveStatusData
                                        .filter(({ total }) => total > 0)
                                        .map(({ label, total }) => (
                                            <a onClick={() => this.props.onClick(label)} key={label}>
                                                <DataCard
                                                    title={label}
                                                    message={`${total}`}
                                                    color={this.labelStore.labelCardColor(label)}
                                                    total={total}
                                                />
                                            </a>
                                        ))}

                                    <a
                                        className={
                                            this.appStore.storage.theme == 'dark-theme'
                                                ? 'btn btn-outline-white btn-block'
                                                : 'btn btn-outline-primary btn-block'
                                        }
                                        onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
                                            this.props.onClick(Labels.TotalDisplays)
                                        }
                                    >
                                        Reset
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    @computed
    private get liveStatusData() {
        return this.biStore.displayStatusTotal.data.map((d, idx) => {
            return {
                total: d,
                label: this.biStore.displayStatusTotal.labels[idx],
                backgroundColor: this.labelStore.labelChartColor(this.biStore.displayStatusTotal.labels[idx]),
            };
        });
    }

    @computed
    private get statusColor() {
        switch (this.biStore.dashboardDisplaysTitle) {
            default:
                return 'gray';
            case Labels.Playing:
                return 'teal';
            case Labels.Warning:
                return 'warning';
            case Labels.NotPlaying:
                return 'danger';
        }
    }
    @inject
    private labelStore!: LabelStore;
    @inject
    private appStore!: AppStore;
    @inject
    private biStore!: BiStore;
}
